module.exports = __webpack_public_path__ + "img/index_banner04.8613cf8f.jpg";